import { defineMessages } from 'react-intl';

export default defineMessages({
  // Drawer messages
  drawerTitle: {
    description: 'Title for the forecasting drawer with warehouse name',
    defaultMessage: 'Reorder Assist',
    id: 'yk/19U',
  },
  closeDrawerAriaLabel: {
    description: 'Aria label for the close button in the forecasting drawer',
    defaultMessage: 'Close forecasting drawer',
    id: 'pZOtbW',
  },

  exportToCsvButton: {
    description: 'Label for the export to CSV button',
    defaultMessage: 'Export to CSV File',
    id: 'HNx0eP',
  },
  createPurchaseOrderButton: {
    description: 'Label for the create purchase order button',
    defaultMessage: 'Create Purchase Order',
    id: 'aTtc0M',
  },

  // Date Range messages
  dateRangeLabel: {
    description: 'Label for forecast period dropdown',
    defaultMessage: 'Forecast:',
    id: '1Gt2io',
  },
  lookbackPeriodLabel: {
    description: 'Label for lookback period dropdown',
    defaultMessage: 'Lookback:',
    id: '9/dpcJ',
  },
  dateRange30Days: {
    description: 'Option for 30 days date range',
    defaultMessage: '30 Days',
    id: 'dY8Lpw',
  },
  dateRange60Days: {
    description: 'Option for 60 days date range',
    defaultMessage: '60 Days',
    id: '1ea2RH',
  },
  dateRange3Months: {
    description: 'Option for 3 months date range',
    defaultMessage: '3 Months',
    id: 'daeWNJ',
  },
  dateRange6months: {
    description: 'Option for 6 months date range',
    defaultMessage: '6 Months',
    id: '0i92FJ',
  },
  dateRange1Year: {
    description: 'Option for 1 year date range',
    defaultMessage: '1 Year',
    id: '10tRr2',
  },
  dateRange2Years: {
    description: 'Option for 2 years date range',
    defaultMessage: '2 Years',
    id: 'AlaI57',
  },

  // Sales Trend Modifier messages
  salesTrendModifierLabel: {
    description: 'Label for sales trend modifier input',
    defaultMessage: 'Sales Trend (% growth)',
    id: '0uDj+q',
  },
  salesTrendModifierDescription: {
    description: 'Description for sales trend modifier',
    defaultMessage:
      'Adjusts the forecast based on expected sales trends. Positive values increase the forecast to account for anticipated growth, while negative values decrease it for expected decline.',
    id: '7GDl2j',
  },

  // Lead Time Modifier messages
  leadTimeModifierLabel: {
    description: 'Label for lead time modifier input',
    defaultMessage: 'Lead Time (Days)',
    id: 'HIT1ta',
  },
  leadTimeModifierDescription: {
    description: 'Description for lead time modifier',
    defaultMessage:
      "The number of days it typically takes for new inventory to arrive after placing an order. A longer lead time means you'll need to reorder sooner to avoid stockouts. This value is used if the product lead time is empty.",
    id: '+gXeaz',
  },

  // Buffer Stock Modifier messages
  bufferStockModifierLabel: {
    description: 'Label for buffer stock modifier input',
    defaultMessage: 'Buffer Stock (Days)',
    id: 'Jqs7vb',
  },
  bufferStockModifierDescription: {
    description: 'Description for buffer stock modifier',
    defaultMessage:
      'Extra inventory (measured in days of supply) to maintain as a safety buffer against unexpected demand spikes or supply chain disruptions. Higher values provide more protection against stockouts but increase holding costs.',
    id: '2U5Rqf',
  },

  // Apply and Reset buttons
  applySettingsButton: {
    description: 'Label for the apply settings button',
    defaultMessage: 'Apply',
    id: 'xXfhKf',
  },
  resetSettingsButton: {
    description: 'Label for the reset settings button',
    defaultMessage: 'Reset',
    id: '3FVdXP',
  },
});
